import React, { Component } from 'react';
import { useContext, useEffect, useState } from "react";
import { Modal, Button } from 'react-bootstrap';
import { CHAINS, frontendurl, AdminSaleAddress, API_URL } from "../config/env";
import wall1 from "../images/metamask_wallet.png";
import wall2 from "../images/connect_wallet.png";
import wall3 from "../images/wall3.png";

import { MetamaskWallet, WalletConnect } from "../hooks/useWallet";
import Web3 from 'web3';
import { Link } from 'react-router-dom';


class Createmodal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            likenotfiModal: true,

        };
    }




    render() {

        const { likenotfiModal } = this.state

        return (

            <>

                <Modal className="wallet-modal" show={likenotfiModal} centered size="md">
                    <Modal.Header className='pt-3 header_odal_head'>
                        <h2 className="sec-head ">Notification</h2>
                        <button type="button" class="close" onClick={() => { this.props.onDismiss() }}><span aria-hidden="true">×</span><span class="sr-only">Close</span></button>
                    </Modal.Header>
                    <Modal.Body className="select-wallet modal_body pt-0 pb-0 px-3">
                        <div>
                            <p className='notfi_text'>Only native token holders can vote the sale</p>
                        </div>
                        <div className='d-flex justify-content-end mb-3'>
                            <Link to={`/bdagsale/${AdminSaleAddress}`}><button className='get-started-btn explore-btn notfibtn'>Yes</button></Link>
                            <button className='get-started-btn explore-btn notfibtn ml-2' onClick={() => { this.props.onDismiss() }}>No</button>
                        </div>
                    </Modal.Body>

                </Modal>

            </>

        )
    }

}


export default Createmodal